import Relay from 'react-relay/classic';

export const ViewerFragment = Relay.QL`
    fragment on Viewer {
        user(userId: $userId) @include(if: $hasUserId) {
            isVerifiedTrade
            verifiedTradeSubStatus
        }
        item(itemId: $itemId) {
            pricing {
                prices {
                    type
                    status
                    amount {
                        convertedAmounts {
                            USD
                        }
                    }
                }
            }
        }
        confirmedTransactions: transactions(buyerId: $userId, viewName: "buyerTracking.confirmed", first: 0) {
            totalResults
        }
    }
`;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/verifiedTradePromoFragments.es.js